import { api } from './api'

const getUserNotifications = async (params = {}) => {
  const response = await api.get('/notifications', { params })
  return response.data
}

const markAsRead = async (id) => {
  const response = await api.patch(`/notifications/${id}/read`, {})
  return response.data
}

const markAllAsRead = async () => {
  const response = await api.patch('/notifications/read-all', {})
  return response.data
}

const connectStream = ({ token, onEvent, onError }) => {
  const baseUrl = (api.defaults.baseURL || '/api').replace(/\/$/, '')
  const streamUrl = `${baseUrl}/notifications/stream?token=${encodeURIComponent(token)}`
  const eventSource = new EventSource(streamUrl)

  eventSource.addEventListener('notification:new', (event) => onEvent?.('notification:new', event))
  eventSource.addEventListener('notification:unread_count', (event) => onEvent?.('notification:unread_count', event))
  eventSource.addEventListener('notification:refresh', (event) => onEvent?.('notification:refresh', event))
  eventSource.addEventListener('notification:connected', (event) => onEvent?.('notification:connected', event))
  eventSource.onerror = (error) => onError?.(error)

  return eventSource
}

const getPreferences = async () => {
  const response = await api.get('/notifications/preferences')
  return response.data
}

const updatePreferences = async (data) => {
  const response = await api.put('/notifications/preferences', data)
  return response.data
}

export default {
  getUserNotifications,
  markAsRead,
  markAllAsRead,
  connectStream,
  getPreferences,
  updatePreferences,
}
